import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat',
  standalone: false
})
export class NumberFormatPipe implements PipeTransform {

  transform(value: number, options: Intl.NumberFormatOptions = {}, locale: string = 'en'): string {
    return new Intl.NumberFormat(locale, options).format(value);
  }

}
